import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export default function render(_ctx, _cache) {
  return (_openBlock(), _createBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, [
    _createVNode("path", {
      "fill-rule": "evenodd",
      d: "M12.013 2.25a.75.75 0 01.75.75l-.012 16.19 5.72-5.708a.75.75 0 111.059 1.061l-7 6.988a.75.75 0 01-1.06 0l-7-6.988a.75.75 0 011.06-1.061l5.721 5.71L11.262 3a.75.75 0 01.751-.75z",
      "clip-rule": "evenodd"
    })
  ]))
}